/**
 * 列表请求的 page_size 归一化。
 *
 * 背景（2026-09-24 体检发现）：网关 `cmd/erp-api/main.go` 与各服务的分页助手对「page_size 超上限」
 * 的处理是**重置为默认 20**（`if pageSize < 1 || pageSize > 100 { pageSize = 20 }`），而不是夹到上限。
 * 于是前端普遍写的 `page_size: 200`（或 500）**只会拿回 20 条** —— 列表被静默截断：
 * 页面提示「共 N 条」是本地条数、分页器也消失，看不出任何异常（线上销售线索 40 条只显示 20 条即由此而来）。
 *
 * 服务端真正接受的最大值是 100（少数端点是 500），这里统一夹到 100：
 * 宁可少要，也不要「以为拿了 200 条、实际只有 20 条」。
 *
 * 2026-09-24 已把服务端那批「超限→退回默认 20」改为「夹到上限」（`parsePageSize(q, def, max)`，
 * 见 docs/role-health-2026-09-24.md 批次十一）；这里的前端夹取**保留**作为双保险，
 * 也顺带统一了「单次最多 100 条」这一约定。
 *
 * 注：真正要看全量时应当翻页（各端点分页参数不统一：有的用 page_token、有的用 pagination.page），
 * 因此这里只做「不超上限」的收口；服务端那批重置写法本身也应改成夹取（已记入体检报告遗留）。
 */
export const MAX_PAGE_SIZE = 100;

/** 兼容两种入参形态：顶层 `page_size`（多数端点）与嵌套 `pagination.page_size`（库存/质量等） */
export function clampPageSize(params: Record<string, unknown> | undefined): Record<string, unknown> | undefined {
  if (!params || typeof params !== "object") return params;
  let next = params;
  if (typeof params.page_size === "number" && params.page_size > MAX_PAGE_SIZE) {
    next = { ...next, page_size: MAX_PAGE_SIZE };
  }
  const nested = params.pagination;
  if (nested && typeof nested === "object" && typeof (nested as { page_size?: unknown }).page_size === "number") {
    const inner = nested as { page_size: number };
    if (inner.page_size > MAX_PAGE_SIZE) next = { ...next, pagination: { ...inner, page_size: MAX_PAGE_SIZE } };
  }
  return next;
}
